import { render, staticRenderFns } from "./SignableDocumentsListNew.vue?vue&type=template&id=1af543a6&scoped=true&"
import script from "./SignableDocumentsListNew.vue?vue&type=script&lang=ts&"
export * from "./SignableDocumentsListNew.vue?vue&type=script&lang=ts&"
import style0 from "./SignableDocumentsListNew.vue?vue&type=style&index=0&id=1af543a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af543a6",
  null
  
)

export default component.exports